import React from "react";
import { useNavigate } from "react-router-dom";
import "./Category.css";

import menImg from "../Assets/Frontend_Assets/finalmen.jpg";
import womenImg from "../Assets/Frontend_Assets/finalfemale.webp";
import kidsImg from "../Assets/Frontend_Assets/fiinalkids.webp";

const Category = () => {
  const navigate = useNavigate();

  return (
    <div className="category-section">
      
      <div className="category-card d-none" onClick={() => navigate("/men")}>
        <img src={menImg} alt="Men" />
        <div className="category-overlay"></div>
        <div className="category-text">
          <h2>MEN</h2>
          <p>Classic & Modern Wear</p>
        </div>
      </div>

      <div className="category-card" onClick={() => navigate("/women")}>
        <img src={womenImg} alt="Women" />
        <div className="category-overlay"></div>
        <div className="category-text">
          <h2>WOMEN</h2>
          <p>Elegant & Stylish Fashion</p>
        </div>
      </div>

      <div className="category-card d-none" onClick={() => navigate("/kids")}>
        <img src={kidsImg} alt="Kids" />
        <div className="category-overlay"></div>
        <div className="category-text">
          <h2>KIDS</h2>
          <p>Comfort & Fun Styles</p>
        </div>
      </div>

    </div>
  );
};

export default Category;
